import { createFormat } from 'Common/utilities/formatting/numbers';

export default createFormat();
